import React from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { getMemberSince } from "../AllDateTimeReleventFormate";

export default function CustomeDeadlineDateLabel({ type, last_date }) {
  return (
    <>
      {type == 3 ? (
        ""
      ) : (
        <p>
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
            alt=""
          />
          Deadline:&nbsp; {getMemberSince(last_date)}
        </p>
      )}
    </>
  );
}
